import { useCallback, useState } from 'react'
import { useOutlet } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { PeriodWizard } from 'modules/planning/components/PeriodWizard'
import PeriodsList from 'modules/planning/components/PeriodsList'

import { PlanningPeriodNode } from 'modules/planning/types/queries'
import { F0Box } from '@factorialco/f0-react'
import { useHeadcountPlanningOne } from 'modules/planning/hooks/useHeadcountPlanningOne'

const HeadcountPlanningPage = () => {
  const { navigation } = useNavigation()
  const outlet = useOutlet()
  const [canCreatePeriod, setCanCreatePeriod] = useState(false)
  const [isWizardOpen, setIsWizardOpen] = useState(false)

  const handleStartFromScratch = useCallback(() => {
    setIsWizardOpen(true)
  }, [])

  const { handleCreatePeriod } = useHeadcountPlanningOne({
    canCreatePeriod,
    onStartFromScratch: handleStartFromScratch,
  })

  const itemUrl = (item: PlanningPeriodNode) =>
    navigation.finance.financialWorkspace.headcountPlanning.periodDetail.fullPath({
      periodId: item.id,
    })

  return (
    <ResponsivePage.Body variant="fullscreen">
      <F0Box paddingTop="lg">
        {outlet ?? (
          <PeriodsList
            periodType="headcount"
            itemUrl={itemUrl}
            handleCreatePeriod={handleCreatePeriod}
            setCanCreatePeriod={setCanCreatePeriod}
          />
        )}
      </F0Box>
      {isWizardOpen && (
        <PeriodWizard
          onClose={() => setIsWizardOpen(false)}
          onSuccess={() => setIsWizardOpen(false)}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default HeadcountPlanningPage
